import script from "./report2Config.vue?vue&type=script&setup=true&lang=js"
export * from "./report2Config.vue?vue&type=script&setup=true&lang=js"

import "./report2Config.vue?vue&type=style&index=0&id=6d780098&lang=less"

const __exports__ = script;

export default __exports__